"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles2 = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _styles2.makeStyles)({
  labelContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  typographyContainer: {
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  typographyLeft: {
    float: 'left'
  },
  typographyRight: {
    float: 'right'
  },
  subtitleTypography: {
    fontWeight: 400
  }
});

var TabLabel = function TabLabel(_ref) {
  var label = _ref.label,
      subtitle = _ref.subtitle,
      icon = _ref.icon,
      data = _ref.data;

  var _styles = styles(),
      labelContainer = _styles.labelContainer,
      typographyContainer = _styles.typographyContainer,
      typographyLeft = _styles.typographyLeft,
      typographyRight = _styles.typographyRight,
      subtitleTypography = _styles.subtitleTypography;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: labelContainer
  }, icon, /*#__PURE__*/_react.default.createElement("div", {
    className: typographyContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: typographyLeft,
    color: "inherit"
  }, label), /*#__PURE__*/_react.default.createElement("label", {
    className: typographyRight
  }, data), subtitle && /*#__PURE__*/_react.default.createElement("div", {
    className: subtitleTypography,
    color: "inherit"
  }, subtitle)));
};

var _default = TabLabel;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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